import { Pipe, PipeTransform, Inject, LOCALE_ID } from '@angular/core';
import { formatDate } from '@angular/common';
import { AppConfigurationService } from '../services/app.configuration.service';
@Pipe({
  name: 'customdateformat',
})
export class CustomDateFormatPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale: string, public appConfig: AppConfigurationService) {}
  transform(date: any, option: string = 'date') {
    const FieldNames: any = this.appConfig.getByIdentifier('custom-date-formats');
    const timeZone: any = this.appConfig.getByIdentifier('portal-timezone');

    if (date) {
      switch (option) {
        case 'date':
          return formatDate(date, FieldNames.Fields.date, this.locale, timeZone?.Fields?.equal?.value);
        case 'time':
          return formatDate(date, FieldNames.Fields.time, this.locale, timeZone?.Fields?.equal?.value);
        case 'datetime':
          return formatDate(date, FieldNames.Fields.datetime, this.locale, timeZone?.Fields?.equal?.value);
        case 'day':
          return formatDate(date, FieldNames.Fields.day, this.locale, timeZone?.Fields?.equal?.value);
        case 'datemonthyear':
          return formatDate(date, FieldNames.Fields.datemonthyear, this.locale, timeZone?.Fields?.equal?.value);
        case 'duedate':
          return formatDate(date, FieldNames.Fields.date, this.locale, timeZone?.Fields?.equal?.value);
      }
    }
    return date;
  }

  getFormat(option: string = 'date') {
    const FieldNames: any = this.appConfig.getByIdentifier('custom-date-formats');
    switch (option) {
      case 'date':
        return FieldNames.Fields.date;
        break;
      case 'time':
        FieldNames.Fields.time;
        break;
      case 'datetime':
        return FieldNames.Fields.datetime;
    }
    return FieldNames.Fields.date;
  }
  getFormatForCalendarControlDateFormat(option: string = 'date'): string {
    return (this.getFormat(option) as string).toLowerCase().replace('yyyy', 'yy');
  }
}
